import React from "react";
import { Avatar, Box, Button, Card, Dropdown, Grid, Icon, Text } from "~/components-shared";
import lists from "~/lib/lists";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { AuthoritiesEnum, RoutesEnum } from "~/types/enums";
import useAbacExt from "~/hooks/abac";
import manageCompaniesActionCreators from "~/store/manageCompanies/actions";
import { ManageCompaniesActionEnum } from "~/store/manageCompanies/types";
import { useDispatch } from "react-redux";
import api from "~/lib/api";
import { helpers } from "~/lib/helpers";
const Actions = styled(Box)`
  position: absolute;
  top: 3px;
  right: 3px;
  background: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.primary;
}};
  padding: 2px;
  border-radius: 2em;
`;
const CompanyManagementMemberCard = _ref2 => {
  let {
    companyId,
    member,
    onClick,
    ...rest
  } = _ref2;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const handleAuthMember = () => {
    api.authManageCompanyMember(companyId, member.id).then(response => {
      window.open(`${RoutesEnum.ROOT}?authToken=${response.token}`, "blank");
    });
  };
  const handleUpdate = () => {
    dispatch(manageCompaniesActionCreators.actionChanged(ManageCompaniesActionEnum.UPDATE_MEMBER, companyId, member));
  };
  const handleDelete = () => {
    dispatch(manageCompaniesActionCreators.actionChanged(ManageCompaniesActionEnum.DELETE_MEMBER, companyId, member));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 2,
    template: "4rem 1fr"
  }, /*#__PURE__*/React.createElement(Avatar, {
    style: {
      verticalAlign: "text-bottom"
    },
    size: 13,
    user: member,
    s: {
      mr: 1
    }
  }), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    fontSize: 3,
    color: "primary"
  }, lists.members.statuses.shortenNames[member.status], " as ", member.role.name), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    weight: "semiBold",
    fontSize: 4,
    lineHeight: 5
  }, member.firstName, " ", member.lastName), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 3
  }, member.email))), userHas(AuthoritiesEnum.MANAGE_COMPANIES_WRITE) && /*#__PURE__*/React.createElement(Actions, {
    align: "center"
  }, helpers.sensitiveAuthorities.some(authority => member.authorities?.includes(authority)) && /*#__PURE__*/React.createElement(Icon, {
    color: "danger",
    src: "infoOutline",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": `<strong>Sensitive authorities assigned:</strong><br/>${member.authorities?.filter(authority => helpers.sensitiveAuthorities.includes(authority)).join("<br/>")}`,
    s: {
      mr: 2
    }
  }), member.settings?.pendingIntegrationChannels && /*#__PURE__*/React.createElement(Icon, {
    s: {
      mr: 1
    },
    src: "webhook",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Notify about new integration channels"
  }), member.email && /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      p: 2
    },
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("CompanyManagement.openWebsite"),
    onClick: () => handleAuthMember()
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "login",
    display: "block"
  })), /*#__PURE__*/React.createElement(Dropdown, {
    direction: "bottomLeft",
    handlerProps: {
      s: {
        p: 2
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.options")
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      src: "dots-vertical",
      color: "text",
      display: "block"
    })
  }, _ref3 => {
    let {
      isOpen,
      onItemClick
    } = _ref3;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        handleUpdate();
        onItemClick();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      scale: 4.5,
      src: "pencil",
      s: {
        mr: 2
      },
      color: "primary"
    }), t("common.actions.edit")), /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        handleDelete();
        onItemClick();
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      scale: 4.5,
      src: "bin",
      s: {
        mr: 2
      },
      color: "danger"
    }), t("common.actions.delete")));
  })));
};
export default CompanyManagementMemberCard;